/* src/app/leave-adjustment/presenter/leave-adjustment-presenter.component.scss */
body#themeTag :host ::ng-deep .p-panel-header {
  background-color: rgba(51, 121, 183, 0.0941176471) !important;
}
:host ::ng-deep .p-datatable-scrollable-body {
  overflow-y: scroll;
  scrollbar-gutter: stable;
}
/*# sourceMappingURL=leave-adjustment-presenter.component.css.map */
